import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="relative bg-navy-900 py-20 px-4" data-id="element-69">
      <div className="max-w-2xl mx-auto text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-71">
          {/* Shield icon */}
          <div className="w-24 h-24 rounded-full gold-gradient-bg flex items-center justify-center mx-auto mb-8 shadow-lg" style={{
          boxShadow: '0 0 40px rgba(201,168,76,0.3)'
        }} data-id="element-72">
            <Shield size={44} className="text-navy-900" data-id="element-73" />
          </div>

          <p className="font-lato text-gold-400 text-sm font-bold tracking-widest uppercase mb-4" data-id="element-74">
            Sin Riesgo
          </p>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-cream mb-8 leading-tight" data-id="element-75">
            Garantía Total de <span className="gold-gradient-text" data-id="element-76">7 Días</span>
          </h2>

          <div className="navy-card rounded-2xl p-8 border border-gold-500/20" data-id="element-77">
            <p className="font-lato text-cream/80 text-lg leading-relaxed mb-6" data-id="element-78">
              Si en 7 días aplicando el protocolo no ves una mejora en los
              despertares nocturnos,{' '}
              <strong className="text-gold-300" data-id="element-79">
                te devuelvo cada centavo.
              </strong>
            </p>
            <p className="font-lato text-cream/80 text-lg leading-relaxed mb-6" data-id="element-80">
              Sin preguntas. Sin formularios complicados. Sin esperas.
            </p>
            <p className="font-playfair text-xl font-bold text-cream italic" data-id="element-81">
              "Porque sé lo que es estar en tu lugar."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}